import BTabs from "@/components/bootstrap/BTabs.vue";
import BTab from "@/components/bootstrap/BTab.vue";

export function installBootstrapTabs(app) {
	app.component("b-tabs", BTabs);
	app.component("b-tab", BTab);
}
